export default __webpack_public_path__ + "static/media/module-option-icon.c245a70b.svg";